import { media, styled } from '@styles';
import { css } from 'styled-components';

import { Container } from '@components/templates/Container';
// import { pageTitle } from '@styles/utils';

const pageTitle = css`
  ${({ theme }) => css`
    position: relative;
    font-size: ${(props) => props.theme.typography.h2FontSize};
    font-family: ${(props) => props.theme.typography.thinFontFamily};
    line-height: 1em;
    font-weight: lighter;
    color: ${theme.colors.baseFont};
    letter-spacing: -0.5px;
    padding: 40px 0 0;
    ${media.largeScreen`
      padding: 30px 0 0;
    `}
    ${media.smallScreen`
      padding: 15px 0 0;
    `}
    * {
      font: inherit;
    }
  `}
`;

export const Wrapper = styled(Container)`
  padding-bottom: 80px;
  padding-top: 80px;
  ${media.largeScreen`
    padding-bottom: 60px;
    padding-top: 60px;
  `}
  ${media.smallScreen`
    padding-bottom: 40px;
    padding-top: 40px;
  `}
`;

export const Title = styled.div`
  margin-bottom: 30px;
  ${media.smallScreen`
    margin-bottom: 20px;
  `}
  ${pageTitle}
`;

export const List = styled.h2`
  & > div {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    ${media.smallScreen`
      grid-template-columns: repeat(2, minmax(0, 1fr));
    `}
  }
`;
